import { Component, Input, ViewChild, ComponentFactoryResolver, AfterViewInit, ComponentRef, OnDestroy } from '@angular/core';
import { ComponentHostDirective } from 'src/app/modules/core/directives/component-host.directive';
import { IWidgetConfiguration } from '../../interfaces/widget';
import { WidgetRequestComponent } from '../widget-request/widget-request.component';
import { BooleanStateService } from 'src/app/modules/core/services/boolean-state.service';
import { WidgetConfigurationService } from '../../services/widget-configuration.service';

@Component({
  selector: 'app-widget-wrapper',
  templateUrl: './widget-wrapper.component.html',
  styleUrls: ['./widget-wrapper.component.scss'],
  providers: [BooleanStateService]
})
export class WidgetWrapperComponent implements AfterViewInit, OnDestroy {

  @Input()
  public configuration: IWidgetConfiguration;

  @ViewChild(ComponentHostDirective, {static: false})
  protected componentHost: ComponentHostDirective;

  protected componentRef: ComponentRef<any>;

  constructor(
    protected componentFactoryResolver: ComponentFactoryResolver,
    protected widgetConfigurationService: WidgetConfigurationService
  ) { }

  public ngAfterViewInit(): void {
    if (this.configuration) {
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.configuration.component);
      const viewContainerRef = this.componentHost.viewContainerRef;
      this.componentRef = viewContainerRef.createComponent(componentFactory);
      (this.componentRef.instance as WidgetRequestComponent).data = this.configuration.componentData;
      this.componentRef.changeDetectorRef.detectChanges();
    }

    this.widgetConfigurationService.widgetConfigurationChange$.subscribe((config: IWidgetConfiguration) => this.configuration = config);
  }

  public ngOnDestroy(): void {
    if (this.componentRef) {
      this.componentRef.changeDetectorRef.detach();
    }
  }
}
